<div class="wetter_content_container">
  <h3>Biowetterbericht</h3>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Biowetter Online</span>
    {{biowetter?.biowetterOnline?.biowetterBeschreibung}}
  </div>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Biowetter Open Media</span>
    {{biowetter?.biowetterOpenMedia?.biowetterBeschreibung}}
  </div>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Biowetter Videotext</span>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">Überschrift</span>
      {{biowetter?.biowetterVideotext?.ueberschrift}}
    </div>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">Biowetter</span>
      {{biowetter?.biowetterVideotext?.biowetterBeschreibung}}
    </div>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">Ozon</span>
      {{biowetter?.biowetterVideotext?.ozonBeschreibung}}
    </div>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">UV</span>
      {{biowetter?.biowetterVideotext.uvBeschreibung}}
    </div>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">Videotext Seite</span>
      {{biowetter?.biowetterVideotext?.vtx_seite}}
    </div>
  </div>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Ozon Open Media</span>
    {{biowetter?.ozonOpenMedia?.ozonBeschreibung}}
  </div>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Pollenflug Online</span>
    <p>{{biowetter?.pollenflugOnline?.pollenflug?.entwicklung}}</p>
    <p>{{biowetter?.pollenflugOnline?.pollenflug?.zustand}}</p>
  </div>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Pollenflug Open Media</span>
    <p>{{biowetter?.pollenflugOpenMedia?.pollenflug?.entwicklung}}</p>
    <p>{{biowetter?.pollenflugOpenMedia?.pollenflug?.zustand}}</p>
  </div>
  <div class="bericht-text-container">
    <span class="bericht-text-sub-label">Pollenflug Videotext</span>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">Videotext Seite</span>
      {{biowetter?.pollenflugVideotext?.vtx_seite}}
    </div>
    <div class="bericht-text-container">
      <span class="bericht-text-sub-label">Pollenflug</span>
      <p>{{biowetter?.pollenflugVideotext?.pollenflug?.entwicklung}}</p>
      <p>{{biowetter?.pollenflugVideotext?.pollenflug?.zustand}}</p>
    </div>
  </div>
</div>
